import Footer from "../../components/common/footer";
import HeaderTwo from "../../components/common/headerTwo";
import { Helmet } from "react-helmet";
import Offer2PraceZiemne from "../../components/offer/2praceZiemne";

function K1MulczerLesny() {
  return (
    <>
      <Helmet>
        <title>Prace ziemne pod budowę domu i wykopy minikoparką | Gdańsk, Gdynia, Kaszuby</title>
        <meta name="title" content="Prace ziemne pod budowę domu i wykopy minikoparką | Gdańsk, Gdynia, Kaszuby" />
        <meta
          name="description"
          content="Specjalistyczne roboty i prace ziemne, wykopy pod fundamenty, przyłącza oraz niwelacje minikoparką. Obszar działania: Gdańsk, Gdynia, Wejherowo, Kartuzy, Kaszuby."
          key="desc"
        />
        <meta
          property="og:title"
          content="Prace ziemne pod budowę domu i wykopy minikoparką | Gdańsk, Gdynia, Kaszuby"
        />
        <meta
          property="og:description"
          content="Specjalistyczne roboty i prace ziemne, wykopy pod fundamenty, przyłącza oraz niwelacje minikoparką. Obszar działania: Gdańsk, Gdynia, Wejherowo, Kartuzy, Kaszuby."
        />
        <meta
          property="og:image"
          content="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <Offer2PraceZiemne />
      </main>
      <Footer />
    </>
  );
}
export default K1MulczerLesny;
